module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "landing-how-we-work"
  }, [_c('div', {
    staticClass: "inner-container"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Como nós trabalhamos")]), _vm._v(" "), _c('div', {
    staticClass: "list row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "image red"
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Propósito")]), _vm._v(" "), _c('p', [_vm._v("Fazer dos empreendedores a força de prosperidade da nossa sociedade.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "image light-blue"
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Guildas")]), _vm._v(" "), _c('p', [_vm._v("São comunidades de interesse. Incluem pessoas de diferentes Times e Tribos que se unem para trocar experiências, melhores práticas e definir iniciativas a serem realizadas dentro dos times.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "image dark-blue"
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Missão")]), _vm._v(" "), _c('p', [_vm._v("Simplificar a vida financeira de empreendedores e pequenas negócios.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "image purple"
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Squads")]), _vm._v(" "), _c('p', [_vm._v("Os times são autônomos e possuem missões próprias de longo prazo. Possuem todos os recursos para resolver problemas e criar experiências de forma independente. Operam como mini-startups. Geralmente são compostos por pessoas de produtos, designers, desenvolvedores e analistas de teste.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "image yellow"
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Agile + Lean")]), _vm._v(" "), _c('p', [_vm._v("Trabalhamos com a metodologia ágil. Nós lançamos features e produtos quando nos sentimos confiantes da sua estabilidade e do seu impacto; temos compromisso com as nossas entregas no dia-a-dia e avisamos (com transparência) nossos colegas, clientes e o restante da empresa se algo saiu do previsto. Acreditamos que 100% de previsibilidade = 0% de inovação e 0% de previsibilidade = 100% caos;\n          ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7466b0dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingHowWeWork.vue
// module id = 143
// module chunks = 1